export default class pages {
  constructor() {
    this.state = {};
  }

  init() {
    console.log(`Hello from ${this.constructor.name}!`);
    // this.toggleGrid();
    // this.sideNav();
    this.video();
    this.mapPopup();
    this.mapList();
  }

  toggleGrid() {
    $('a[href="#view-as-list"]').click((e) => {
      e.preventDefault();
      let text = $(e.target).text();
      if (text == 'View as Cards') {
        $(e.target).text('Gallery View')
      } else {
        $(e.target).text('View as Cards')
      }
      $('.section').toggleClass('grid');
      $('.grid-container').toggleClass('container')
    })

    $('a[href="#back-to-top"]').click( (e)=>{
      e.preventDefault()
      $('html,body').animate({
        scrollTop: 0
      }, 1000);
    })
    // show back to top
    $(window).scroll(function() {
      if(window.scrollY > 1000){
        $('a[href="#back-to-top"]').addClass('active');
      } else {
        $('a[href="#back-to-top"]').removeClass('active');
      }
    });
  }

  sideNav(){
    // Get all sections that have an ID defined
    var sections = document.querySelectorAll(".anchor-section");

    // Add an event listener listening for scroll
    window.addEventListener("scroll", navHighlighter, { passive: true });

    function navHighlighter() {
      
      // Get current scroll position
      var scrollY = window.pageYOffset;
      
      // Now we loop through sections to get height, top and ID values for each
      sections.forEach(function(current) {
        //console.log(current.getAttribute("id"));
        var sectionHeight = current.offsetHeight - 100;
        var sectionTop = current.offsetTop - 100;
        var sectionId = '#'+current.getAttribute("id");
        //console.log(sectionId);
        // console.log('#'+current.getAttribute("id"), sectionHeight, sectionTop)
        /*
        - If our current scroll position enters the space where current section on screen is, add .active class to corresponding navigation link, else remove it
        - To know which link needs an active class, we use sectionId variable we are getting while looping through sections as an selector
        */
        if (
          scrollY > sectionTop && 
          scrollY <= sectionTop + sectionHeight
        ){
          $('.side-nav ul li').removeClass('active');
          $(".side-nav a[href='" + sectionId + "']").parent().addClass("active");
        } 
        // else {
        //   $(".navigation a[href='" + sectionId + "']").parent().removeClass("active");
        // }
      });
    }

    $('.side-nav ul a').click(function () {
      let id = $(this).attr('href');
      $('html, body').animate({
          scrollTop: $(id).offset().top - 50
      }, 1000);
  
      return false;
    });
  }

  mapPopup(){
    let popUp = $('.popup-item');
    popUp.on('click', function(e){
      e.preventDefault()
      let blockId = $(this).data('block-id');
      let map = $(this).data('map');
      let image = $(this).data('popup-image');
      let header = $(this).data('popup-header');
      let label = $(this).data('popup-label');
      let icon = $(this).data('icon');
      let btnLabel = $(this).data('btn-label');
      let btnLink = $(this).data('btn-link');
      $(`#${blockId} .image img`).attr('src', map)
      $(`#${blockId} .image .popup img`).attr('src', image);
      $(`#${blockId} .image .popup h5`).text(header);
      $(`#${blockId} .image .popup label img`).attr('src', icon);
      $(`#${blockId} .image .popup label span`).text(label);
      $(`#${blockId} .image .popup a`).attr('href', btnLink).text(btnLabel);
    })
  }

  video(){
    $('.section.video .aspect-ratio').on('click', function(){
      let video = $(this).find('video')
      var myVideo = video[0];
      if (myVideo.paused) {
        myVideo.play(); 
         $(this).find('.play-btn').addClass('hide');
        //  setTimeout(function(){
        //   video.removeClass('poster-view');
        //  }, 200)
      }
      else {
        myVideo.pause();
        $(this).find('.play-btn').removeClass('hide');
      }
       
    })
  }

  mapList(){
    $('.mapList').each(function(){
      let $mapList = $(this);
      let $popup = $mapList.find('.popup');
      $mapList.find('.list li a').on('click', function(e){
        e.preventDefault();
        $(this).parent().addClass('active').siblings('li').removeClass('active');
        $('.embeded-content svg path.location').removeClass('active');
        $('.embeded-content svg path#'+$(this).data('coordinate')).addClass('active');
        let hash = $(this).attr('href');
        let header= $(this).data('popup-header');
        let image = $(this).data('popup-image');
        
        $popup.find('img').attr('src', image);
        $popup.find('h5').text(header);
      })
    }) 
  }
}